/*
 * Copyright (c) 2024. Tooling Team
 */

import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Badge from "react-bootstrap/Badge";

export default function TagsCellRenderer(params) {
  //dynamically render tag names in badges, tag values underneath
  const getPopoverContents = () => {
    return params.data.tags.map((tag, index) => {
      return (
        <div key={index}>
          <Badge bg="secondary">{tag.name}</Badge>
          {tag.values.map((value, index) => {
            return <div key={index}>{value}</div>;
          })}
        </div>
      );
    });
  };

  // retrieve whether this cell was updated from the grid parent
  const isUpdated = params.colDef.cellClassRules["cell-updated"](params);

  if (params.data.tags) {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Header as="h3">{`Row Tags`}</Popover.Header>
        <Popover.Body>{getPopoverContents()}</Popover.Body>
      </Popover>
    );

    return (
      <OverlayTrigger
        trigger={["hover", "focus"]}
        placement="bottom"
        overlay={popover}
      >
        <div className={isUpdated ? "tags-cell-updated" : null}>
          <Button variant="outline-primary" title="Row Tags" size="sm">
            Tags {params.data.tags.length}
          </Button>
        </div>
      </OverlayTrigger>
    );
  } else {
    return null;
  }
}
